import React from "react";

export default function SoftDivider() {
  return (
    <div className="h-16 flex items-center justify-center">
      <div className="w-16 border-t border-taupe/30"></div>
    </div>
  );
}